module.exports = __webpack_public_path__ + "img/finland-ill-defined-causes-male.bb156915.png";